import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './AsideFiltersContainer';
import { LegislationDateSelectors } from './dates/legislation/LegislationDateSelectors';
import { Dates } from './dates/decision/Dates';
import { Categories } from './categories/Categories';
import { Exclude } from './exclude/Exclude';
import { Parties } from './parties/Parties';

export const RawAsideFilters: FC<PropsFromRedux> = ({
  shouldDisplayDate,
  shouldDisplayInForceDate,
  shouldDisplayVille,
  shouldDisplayJuridiction,
  shouldDisplayDomaine,
  shouldDisplayPubli,
  shouldDisplaySolution,
  shouldDisplayPublisher,
  shouldDisplayExclude,
  shouldDisplayParties,
  shouldDisplayTextCode,
  shouldDisplayCollectiveAgreements,
  shouldDisplayOtherLegislation,
}) => {
  return (
    <div className="search-filters">
      {shouldDisplayVille && <Categories type="ville" />}
      {shouldDisplayDate && <Dates />}
      {shouldDisplayInForceDate && <LegislationDateSelectors />}
      {shouldDisplayTextCode && <Categories type="textCode" />}
      {shouldDisplayExclude && <Exclude />}
      {shouldDisplayJuridiction && <Categories type="juridiction" />}
      {shouldDisplayDomaine && <Categories type="domaine" />}
      {shouldDisplayPubli && <Categories type="publi" />}
      {shouldDisplaySolution && <Categories type="solution" />}
      {shouldDisplayPublisher && <Categories type="publisher" />}
      {shouldDisplayParties && <Parties />}
      {shouldDisplayOtherLegislation && <Categories type="otherLegislation" />}
      {shouldDisplayCollectiveAgreements && (
        <Categories type="collectiveAgreements" />
      )}
    </div>
  );
};

export const AsideFilters = Connect(RawAsideFilters);
